import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestArticleCodeService } from 'src/app/service/rest/article-code/rest-article-code.service';
import { environment } from 'src/environments/environment';
import { ArticleCode } from './article-code.model';

@Injectable()
export class ArticleCodesRepositoryService {

  private _articleCodes: ArticleCode[];
  private _selectedArticleCodes: ArticleCode[];
  private _articleCodesLoaded: boolean = false;
  private _selectedArticleCode: ArticleCode;
  private _selectedArticleCodeDocuments: Document[];
  private _selectedArticleCodeImages: Document[];
  private _selectedArticleCodeVideos: Document[];
  
  private _dataSourceArticleCodes = new MatTableDataSource<ArticleCode>();
  
  
  constructor(private restArticle : RestArticleCodeService) {}
  
  get articleCodes(): ArticleCode[] {
    let articleCodes: ArticleCode[];
    if (!this._articleCodes) {
      articleCodes = JSON.parse(sessionStorage.getItem(environment.storage.articleCodes));
      return articleCodes;
    } else{ 
      return this._articleCodes};
  }
  
  set articleCodes(value: ArticleCode[]) {
    if(value) sessionStorage.setItem(environment.storage.articleCodes, JSON.stringify(value));
    this._articleCodes = value;
  }
  
  public get selectedArticleCode(): ArticleCode | undefined {
    return this._selectedArticleCode;
  }
  
  public set selectedArticleCode(value: ArticleCode | undefined) {
    this._selectedArticleCode = value;
  }
  
  public get dataSourceArticleCodes() {
    return this._dataSourceArticleCodes;
  }
  public set dataSourceArticleCodes(value) {
    this._dataSourceArticleCodes = value;
  }
  
  public get selectedArticleCodeVideos(): Document[] {
    return this._selectedArticleCodeVideos;
  }
  public set selectedArticleCodeVideos(value: Document[]) {
    this._selectedArticleCodeVideos = value;
  }
  
  public get selectedArticleCodeImages(): Document[] {
    return this._selectedArticleCodeImages;
  }
  public set selectedArticleCodeImages(value: Document[]) {
    this._selectedArticleCodeImages = value;
  }
  
  public get selectedArticleCodeDocuments(): Document[] {
    return this._selectedArticleCodeDocuments;
  }
  public set selectedArticleCodeDocuments(value: Document[]) {
    this._selectedArticleCodeDocuments = value;
  }
  
  public get selectedArticleCodes(): ArticleCode[] {
    return this._selectedArticleCodes;
  }
  public set selectedArticleCodes(value: ArticleCode[]) {
    this._selectedArticleCodes = value;
  }

  loadArticleCodes(shouldBeReloaded:boolean = false) {
    if (shouldBeReloaded || !this._articleCodesLoaded) {
      this.restArticle.getAllArticleCodes()
      .subscribe(result => {
        this.articleCodes = result;
        this.selectedArticleCodes = result;
       // this.selectedArticleCode = this.articleCodes[0];
      }, error => {
        console.log(error);
      });
    }
    
    this._articleCodesLoaded = true;
  }

  loadArticleCodesByFamilyId(familyId: number): Observable<ArticleCode[]> {
    return this.restArticle.getAllArticleCodesByFamilyId(familyId);
  }
  
  getArticleCodes() : Observable<ArticleCode[]>{
    return this.restArticle.getAllArticleCodes();
  }
}
